export default __webpack_public_path__ + "double-quotes.png?6f8ca94aeed47e72708a8a4966efbac2";